<div class="wrapper">
  <div class="navigation">
    <lms-approval-sandbox-menu></lms-approval-sandbox-menu>
  </div>
  <router-outlet></router-outlet>
</div>
